import { useContext, useEffect, useState } from "react";
import { LangContext } from "../../context/LangContext";
import SelectLang from "../../components/SelectLang";
import ConfirmDelete from "../../components/ConfirmDelete";
import "./style.css"

function Illustrations() {
    const { translations } = useContext(LangContext);

    const [illustrationsList, setIllustrationsList] = useState(null);
    const [illustration, setIllustration] = useState(null);
    const [imgSize, setImgSize] = useState(null);

    const [inSubmit, setInSubmit] = useState(false);
    const [toDelete, setToDelete] = useState(null);

    useEffect(() => {
        const fetchIllustrationsList = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/illustrations/get`);
            const res = await req.json();

            if (req.status !== 200) {
                alert(res.message);
                return
            };
            setIllustrationsList(res.sort((a, b) => a.order - b.order));
        }
        fetchIllustrationsList();
    }, []);

    useEffect(() => {
        if (!illustration?.image?.url) {
            setImgSize(null)
            return;
        }

        const img = new Image();
        img.src = illustration.image.url;

        img.onload = () => {
            setImgSize({ width: img.naturalWidth, height: img.naturalHeight });
        };
    }, [illustration]);

    const newIllustration = (e) => {
        const file = e.target.files[0];
        const url = URL.createObjectURL(file);

        if (!file || !url) {
            alert("Erreur fichier");
            return
        }

        setIllustration({
            title: '',
            serie: '',

            perso: '',
            created: '',
            cg_art: true,

            image: { file, url },
        });
    }

    const setValue = (e, field) => {
        setIllustration({
            ...illustration,
            [field]: e.target.value
        })
    }

    const switchLeft = async (illust) => {
        if (illust.order === illustrationsList.length - 1) return
        const nextIllust = illustrationsList.find(i => i.order === illust.order + 1);

        const req = await fetch(`${process.env.REACT_APP_API_URL}/illustrations/order/${illust._id}/${nextIllust._id}`, {
            method: 'PUT',
            headers: { Authorization: `Bearer ${localStorage.getItem('token_vanrah')}` }
        });
        const res = await req.json();
        if (req.status !== 200) return alert(res.message);

        const newIllustrationsList = illustrationsList.map(item => {
            if (item._id === illust._id) {
                return { ...item, order: item.order + 1 };
            }
            else if (item._id === nextIllust._id) {
                return { ...item, order: item.order - 1 };
            }
            return item;
        });
        newIllustrationsList.sort((a, b) => a.order - b.order);
        setIllustrationsList(newIllustrationsList);
    };

    const switchRight = async (illust) => {
        if (illust.order === 0) return
        const prevIllust = illustrationsList.find(i => i.order === illust.order - 1);

        const req = await fetch(`${process.env.REACT_APP_API_URL}/illustrations/order/${illust._id}/${prevIllust._id}`, {
            method: 'PUT',
            headers: { Authorization: `Bearer ${localStorage.getItem('token_vanrah')}` }
        });
        const res = await req.json();
        if (req.status !== 200) return alert(res.message);

        const newIllustrationsList = illustrationsList.map(item => {
            if (item._id === illust._id) {
                return { ...item, order: item.order - 1 };
            }
            else if (item._id === prevIllust._id) {
                return { ...item, order: item.order + 1 };
            }
            return item;
        });
        newIllustrationsList.sort((a, b) => a.order - b.order);
        setIllustrationsList(newIllustrationsList);
    };

    const submitForm = async (e) => {
        e.preventDefault();

        if (inSubmit) return alert("Chargement en cours, veuillez patienter");
        else setInSubmit(true);

        if (!illustration.title || !illustration.image) {
            alert('Titre ou Image manquant(e)');
            setInSubmit(false);
            return
        }

        const body = new FormData();

        body.append('title', illustration.title);
        body.append('serie', illustration.serie);
        body.append('perso', illustration.perso);
        body.append('cg_art', illustration.cg_art);
        body.append('created', illustration.created);

        body.append('image', illustration.image.file);

        const req = await fetch(`${process.env.REACT_APP_API_URL}/illustrations/${illustration._id ? `edit/${illustration._id}` : 'add'}`, {
            method: illustration._id ? 'PUT' : 'POST',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token_vanrah')}` },
            body: body
        });
        const res = await req.json();
        setInSubmit(false);

        if (req.status !== 201 && req.status !== 200) {
            alert(res.message);
            return
        }

        if (illustration._id) {
            const newList = illustrationsList.map(e => {
                if (e._id === illustration._id) return res;
                return e;
            });
            alert('Illustration modifié avec succès !');
            setIllustrationsList(newList);
            setIllustration(null);
        }
        else {
            setIllustrationsList([
                ...illustrationsList,
                res
            ]);
            alert('Illustration ajouté avec succès !');
            setIllustration(null);
        }
    }

    const deleteIllustration = async () => {
        if (inSubmit) return alert("Chargement en cours, veuillez patienter");
        else setInSubmit(true);

        const req = await fetch(`${process.env.REACT_APP_API_URL}/illustrations/del/${toDelete._id}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token_vanrah')}` }
        });
        const res = await req.json();

        alert(req.status === 200 ? "L'illustration a bien été supprimé" : res.message);
        setInSubmit(false);

        if (req.status === 200) {
            const newIllustList = illustrationsList.filter(i => i._id !== toDelete._id);
            setIllustrationsList(newIllustList);
        }
        setToDelete(null);
    }

    return (
        <div className='page page_illustrations'>
            <p className='title_page'>
                - <span>Illustrations</span> -
            </p>

            <SelectLang />

            <button className="btn_new_item">
                <input type="file" onChange={(e) => newIllustration(e)} />
                + Nouvelle illustration
            </button>

            {illustrationsList && illustrationsList.length !== 0 &&
                <ul className="illustrations_list">
                    {illustrationsList.map((illus, idx) => (
                        <li key={idx}>
                            <button
                                className="onglet"
                                onClick={() => setIllustration(illus)}
                            >
                                <div className="preview">
                                    <i className="img" style={{ backgroundImage: `url(${illus.image._url})` }}></i>
                                </div>

                                <h2>- {illus.title} -</h2>
                            </button>

                            {idx !== illustrationsList.length - 1 &&
                                <button
                                    className="btn_right btn_panel"
                                    onClick={() => switchLeft(illus)}
                                ><i className="fas fa-chevron-right"></i></button>
                            }

                            {idx !== 0 &&
                                <button
                                    className="btn_left btn_panel"
                                    onClick={() => switchRight(illus)}
                                ><i className="fas fa-chevron-left"></i></button>
                            }

                            <button
                                className="del_illustration"
                                onClick={() => setToDelete(illus)}
                            >
                                <i className="fas fa-xmark"></i>
                            </button>
                        </li>
                    ))}
                </ul>
            }

            {illustration && imgSize &&
                <form
                    className="mdl_illustration"
                    onSubmit={(e) => submitForm(e)}
                >
                    <div className="content">
                        <div className="illustration">
                            <i style={{
                                backgroundImage: `url(${illustration.image.url})`,
                                aspectRatio: `${imgSize.width} / ${imgSize.height}`
                            }}></i>
                        </div>

                        <div className="description">
                            <div className="field">
                                <span>{translations.title} :</span>
                                <input
                                    type="text"
                                    placeholder={translations.title}
                                    value={illustration.title}
                                    onChange={(e) => setValue(e, 'title')}
                                />
                            </div>
                            <div className="field">
                                <span>{translations.serie} :</span>
                                <input
                                    type="text"
                                    placeholder={translations.serie}
                                    value={illustration.serie}
                                    onChange={(e) => setValue(e, 'serie')}
                                />
                            </div>
                            <div className="field">
                                <span>Personnage :</span>
                                <input
                                    type="text"
                                    placeholder="Personnage"
                                    value={illustration.perso}
                                    onChange={(e) => setValue(e, 'perso')}
                                />
                            </div>
                            <div className="field">
                                <span>{translations.date_of_creation} :</span>
                                <input
                                    type="text"
                                    placeholder={translations.date_of_creation}
                                    value={illustration.created}
                                    onChange={(e) => setValue(e, 'created')}
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn_submit"
                            >
                                {!illustration._id ? "Ajouter" : "Modifier"}
                            </button>
                        </div>
                    </div>

                    <button
                        className="btn_close"
                        onClick={() => setIllustration(null)}
                    >
                        <i className='fas fa-xmark'></i>
                    </button>
                </form>
            }

            {toDelete &&
                <ConfirmDelete
                    title="Supprimer une illustration"
                    itemName={toDelete.title}
                    setToDelete={setToDelete}
                    _delete={deleteIllustration}
                />
            }
        </div>
    )
}

export default Illustrations;